module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L1SS3T.349e990b.jpg";